import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDoubleCheckIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 22,
	height: 13,
	viewBox: "0 0 22 13",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.65 12.025L0 6.375L1.425 4.975L5.675 9.225L7.075 10.625L5.65 12.025ZM11.3 12.025L5.65 6.375L7.05 4.95L11.3 9.2L20.5 0L21.9 1.425L11.3 12.025ZM11.3 6.375L9.875 4.975L14.825 0.025L16.25 1.425L11.3 6.375Z",
		fill: "currentColor"
	})
});
export default SvgDoubleCheckIcon;
